import { SharedBookingServices } from './shared-booking-services.model';

export const ServiceCategory: Record<
  SharedBookingServices,
  {
    label: string;
    icon: string;
  }
> = {
  SALO: {
    label: 'booking_details_component.other_services_component.booking_services.salo',
    icon: 'ds-icon-vipstar'
  },
  SALD: {
    label: 'booking_details_component.other_services_component.booking_services.sald',
    icon: 'ds-icon-vipstar'
  },
  INST: {
    label: 'booking_details_component.other_services_component.booking_services.inst',
    icon: 'ds-icon-insurance'
  },
  INPL: {
    label: 'booking_details_component.other_services_component.booking_services.inpl',
    icon: 'ds-icon-insurance'
  },
  SED: {
    label: 'booking_details_component.other_services_component.booking_services.sed',
    icon: 'ds-icon-insurance'
  },
  SEA: {
    label: 'booking_details_component.other_services_component.booking_services.sea',
    icon: 'ds-icon-insurance'
  },
  FXPK: {
    label: 'booking_details_component.other_services_component.booking_services.fxpk',
    icon: 'ds-icon-plane-flight-change'
  },
  RFCS: {
    label: 'booking_details_component.other_services_component.booking_services.rfcs',
    icon: 'ds-icon-insurance'
  }
};
